import { component } from 'picoapp';
import { gsap } from 'gsap';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(MorphSVGPlugin);

export default component((node, ctx) => {

  const buttons = document.querySelectorAll('.js-toggle-mobile-navigation');

  const nav = node.querySelector('.js-mobile-navigation');
  const accordionToggles = node.querySelectorAll('.js-open-nested-menu');
  const nestedMenus = [...node.querySelectorAll('.js-menu-nested')];
  const listItems = node.querySelectorAll('.o-list__item');
  const links = node.querySelectorAll('a');

  const openNavigation = () => {
    node.classList.add('is-visible');
    gsap.to(nav, { x: '0%', duration: 0.3 });
    ctx.hydrate({ navOpen: true });
  };

  const closeNavigation = () => {
    ctx.hydrate({ navOpen: false });
    node.classList.remove('is-visible');
    gsap.to(nav, { x: '-100%', duration: 0.3 });
    nestedMenus.forEach(menu => closeNestedMenu(menu)); unfadeAllListItems();
  };

  const toggleNavigation = () => {
    ctx.emit('toggleNavigation', { navOpen: !ctx.getState().navOpen });
  };

  ctx.on('toggleNavigation', ({ navOpen }) => {
    document.body.classList.toggle('no-scroll', navOpen);
    navOpen ? openNavigation() : closeNavigation();
  });

  const toggleMenu = (toggle) => {
    const [menu] = $(toggle).next('.js-menu-nested');
    const isExpanded = menu.dataset.expanded;

    if (isExpanded) {
      closeNestedMenu(menu);
    } else {
      openNestedMenu(toggle, menu);
    }
  };

  const closeNestedMenu = (menu) => {
    $(menu).prev('.js-open-nested-menu').removeClass('is-active');
    menu.removeAttribute('data-expanded');
    unfadeAllListItems();
    const tl = gsap.timeline();
    tl.to(menu, { autoAlpha: 0, duration: 0.1 });
    tl.to(menu, { height: '0' }, '-=0.1');
  };

  const openNestedMenu = (toggle, menu) => {
    menu.setAttribute('data-expanded', true);
    toggle.classList.add('is-active');
    closeAllOtherNestedMenus(menu);
    fadeAllOtherListItems(toggle);
    const tl = gsap.timeline();
    tl.to(menu, { height: 'auto' });
    tl.to(menu, { autoAlpha: 1, pointerEvents: 'auto', duration: 0.4 }, '-=0.2');
  };

  const closeAllOtherNestedMenus = (activeMenu) => {
    const otherMenus = nestedMenus.filter((menu) => menu !== activeMenu);
    otherMenus.forEach(menu => closeNestedMenu(menu));
  };

  const fadeAllOtherListItems = (toggle) => {
    gsap.to(listItems, { opacity: 0.2, duration: 0.2, overwrite: true });
    gsap.set($(toggle).parent(), { opacity: 1, overwrite: true });
    gsap.set($(toggle).next().children(), { opacity: 1, overwrite: true });
  };

  const unfadeAllListItems = () => {
    gsap.to(listItems, { opacity: 1 });
  };

  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      toggleMenu(toggle);
    });
  });

  links.forEach(link => {
    link.addEventListener('click', toggleNavigation);
  });
  buttons.forEach(button => {
    button.addEventListener('click', toggleNavigation);
  });

});